import api from "./api";
import { ENV } from "../utils/constants";

type MyForm = {
    currentPassword : string,
    password: string,
    confirmPassword: string
}

export const putPassword= async (data : MyForm) => {
    const response = await api.put(
      `account-settings-p1-${ENV}/crm/account-settings/company/user/password`,
      data
    );
    
    return response;
  };